import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LanguageService, LanguageOption, SUPPORTED_LANGUAGES } from '../../services/language.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  readonly languageService = inject(LanguageService);
  readonly themeService = inject(ThemeService);
  readonly languages: LanguageOption[] = SUPPORTED_LANGUAGES;
}
